import { Link } from "react-router-dom";
import ShareFeedbackButton from "@/components/feedback/ShareFeedbackButton";
import { BrandMark } from "@/components/brand/BrandMark";

const COLS = [
    {
        title: "Platform",
        items: [
            ["How It Works", "/how-it-works"],
            ["Pricing", "/pricing"],
            ["Upload Inspection", "/upload"],
            ["Sample Analysis", "/sample-analysis"],
        ],
    },
    {
        title: "Resources",
        items: [
            ["Learn", "/learn"],
            ["Repair Costs", "/learn/home-inspection-repair-costs"],
            ["Foundation Issues", "/learn/foundation-cracks-inspection"],
            ["Water Intrusion", "/learn/water-intrusion-inspection"],
            ["Roof Concerns", "/learn/roof-issues-home-inspection"],
            ["Negotiation Guide", "/learn/what-to-negotiate-after-home-inspection"],
        ],
    },
    {
        title: "Company",
        items: [
            ["Contact", "/contact"],
            ["Help Center", "/support"],
            ["Accessibility & Trust Center", "/trust", { strong: true }],
            ["Your Privacy & Data", "/account/privacy"],
            ["Privacy Policy", "/privacy-policy"],
            ["AI Disclosure", "/ai-disclosure"],
            ["Professional Advice Disclaimer", "/professional-disclaimer"],
            ["Affiliate Disclosure", "/affiliate"],
            ["Data Security", "/security"],
            ["Accessibility Statement", "/accessibility"],
            ["Terms", "/terms"],
            ["Cookie Policy", "/cookie-policy"],
            ["Refund Policy", "/refund-policy"],
            ["Do Not Sell or Share", "/account/privacy?action=do-not-sell"],
        ],
    },
];

export default function Footer() {
    return (
        <footer
            className="mt-24 border-t border-bl bg-bl-surface"
            data-testid="footer"
        >
            <div className="bl-container py-16 md:py-20">
                <div className="grid gap-10 md:gap-12 grid-cols-2 md:grid-cols-4">
                    <div className="col-span-2 md:col-span-1">
                        <div className="flex items-center gap-2.5">
                            <BrandMark size={36} className="shrink-0" />
                            <div className="leading-tight">
                                <div className="font-display font-semibold text-bl text-[15px] tracking-tight">
                                    Buyer's Leverage
                                </div>
                                <div className="text-[10px] tracking-[0.22em] text-bl-muted uppercase">
                                    Inspection Intelligence
                                </div>
                            </div>
                        </div>
                        <p className="mt-5 text-sm leading-relaxed text-bl-muted max-w-xs">
                            Understand your inspection. Negotiate with confidence.
                        </p>
                    </div>
                    {COLS.map((c) => (
                        <div key={c.title}>
                            <h4 className="text-[11px] tracking-[0.18em] uppercase text-bl-muted font-medium">
                                {c.title}
                            </h4>
                            <ul className="mt-4 space-y-2.5">
                                {c.items.map((entry) => {
                                    const [label, to, opts] = entry;
                                    const strong = opts && opts.strong;
                                    return (
                                        <li key={to}>
                                            <Link
                                                to={to}
                                                data-testid={`footer-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}-link`}
                                                className={
                                                    "text-sm transition-colors " +
                                                    (strong
                                                        ? "text-bl font-semibold hover:text-bl-primary inline-flex items-center gap-1"
                                                        : "text-bl hover:text-bl-primary")
                                                }
                                            >
                                                {label}
                                                {strong && (
                                                    <span aria-hidden="true">→</span>
                                                )}
                                            </Link>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="bl-divider my-10" />

                <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                    <p className="text-xs text-bl-muted max-w-2xl leading-relaxed">
                        Buyer's Leverage is a decision-support product. It is not legal,
                        engineering, contractor, appraisal, or inspection advice. Repair
                        cost ranges are broad planning estimates. Consider consulting a
                        qualified professional for major concerns.
                    </p>
                    <div className="flex items-center gap-5 flex-wrap">
                        <ShareFeedbackButton sourceLocation="footer" />
                        <Link
                            to="/auth/login?next=/admin"
                            data-testid="footer-admin-link"
                            className="text-xs text-bl-muted hover:text-bl-primary transition-colors"
                            aria-label="Admin sign in"
                        >
                            Admin
                        </Link>
                        <p className="text-xs text-bl-muted">
                            © {new Date().getFullYear()} Buyer's Leverage
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
}
